module.exports = __webpack_public_path__ + "static/img/manual_zh_1.72b8a42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_1.png
// module id = aLGS
// module chunks = 4